<template >
  <b-modal id="modalMessageShipyard" class="modal-box" centered size="lg" ok-only>

    <b-row>
      <b-col lg="2" md="12" class="mobile-only">
        <img :src="shipyard.logo" alt="company_name">
      </b-col>
      <b-col lg="10" md="12">
        <h3>Contact {{ shipyard.name }}</h3>

      </b-col>
      <b-col lg="2" md="12" class="desktop-only">
        <img :src="shipyard.logo" alt="company_name">
      </b-col>
    </b-row>
    <p class="sub_message">You can message {{ shipyard.name }} ask for quotation or anything you need regarding their services or products.</p>
    <b-form>
      <textarea name="message" placeholder="Message" rows="8" cols="80" v-model="message"></textarea>
      <button @click="sendEmail" type="button" name="button" class="btn btn-primary">Send</button>
    </b-form>
  </b-modal>
</template>

<script>
import miscAPI from '@/api/misc'
export default {
  props:["shipyard"],
  data() {
    return {
      message: null
    }
  },
  computed: {
		account() {
			let data = this.$store.state.account.account;

			if(data && data.type == 'user') data.detail = data.user;
			else if(data && data.type == 'shipyard') data.detail = data.shipyard;
			else if(data && data.type == 'vendor') data.detail = data.vendor;

			return data;
		},
  },
  methods:{
    sendEmail(content) {
      let MiscApi = new miscAPI(this.$axios);

      MiscApi.sendMessage({
        'name' : this.shipyard.name,
        'email_to' : this.shipyard.email,
        'username' : this.account.user.name,
        'position' : this.account.user.position || null,
        'email_sender' : this.account.email,
        'message' : this.message
      }).then(res => {
        this.$emit('onMessageSent');
        this.$root.$emit('bv::hide::modal','modalMessageShipyard')
      })
    }
  }
}
</script>

<style lang="scss">
	@import '~/assets/scss/_mixins.scss';
	@import './style.scss';
</style>
